(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bws-pdp-pair_each-quantity"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.bws-product-information').forEach((section) => {
    const purchaseOptions = section.querySelector('[data-bws-purchase-options]');

    if (!purchaseOptions) return;

    const buttons = purchaseOptions.querySelectorAll('[data-quantity]');
    const quantityInput = section.querySelector('product-form-component input[name="quantity"]');
    const productPrice = section.querySelector('.bws-product-information__price');

    if (!quantityInput) return;

    const updatePrice = (button) => {
      const priceContainer = productPrice?.querySelector('[ref="priceContainer"]');
      const price = priceContainer?.querySelector('.price');
      const compareAtPrice = priceContainer?.querySelector('.compare-at-price');
      const suffix = priceContainer?.querySelector('.bws-product-information__price-suffix');
      const isPair = button.dataset.purchaseUnit === 'pair';
      const nextPrice = isPair ? priceContainer?.dataset.bwsPairPrice : priceContainer?.dataset.bwsEachPrice;
      const nextComparePrice = isPair
        ? priceContainer?.dataset.bwsPairComparePrice
        : priceContainer?.dataset.bwsEachComparePrice;

      if (price && nextPrice && price.textContent !== nextPrice) price.textContent = nextPrice;
      if (compareAtPrice && nextComparePrice && compareAtPrice.textContent !== nextComparePrice) {
        compareAtPrice.textContent = nextComparePrice;
      }
      if (suffix) {
        const nextSuffix = isPair ? priceContainer?.dataset.bwsPairSuffix || '' : '';
        if (suffix.textContent !== nextSuffix) suffix.textContent = nextSuffix;
        suffix.hidden = !isPair;
      }
    };

    const setQuantity = (button) => {
      quantityInput.value = button.dataset.quantity;

      quantityInput.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );

      updatePrice(button);

      buttons.forEach((item) => {
        const isActive = item === button;

        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', isActive);
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        setQuantity(button);
      });
    });

    const activeButton = purchaseOptions.querySelector('[data-quantity].active');

    if (activeButton) {
      setQuantity(activeButton);
    }

    if (productPrice) {
      new MutationObserver(() => {
        const selectedButton = purchaseOptions.querySelector('[data-quantity].active');
        if (selectedButton) updatePrice(selectedButton);
      }).observe(productPrice, { childList: true, subtree: true });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
